import policyLawRoute from './policy-law'; // 政策法规
import guidanceRoute from './guidance'; // 办事指南
import PublicAnnouncementRoute from './public-announcement'; // 公示公告
import fileDownloadRoute from './file-download'; // 资料下载
/**
 * 信息查询路由配置
 */
export default {
  path: '/home/xxfw',
  name: 'xxfw',
  component: () => import('iebdc/views/xxfw'),
  meta: {
    label: '信息服务',
    permission: 'IEBDC:SY:XXFW:ZCFG'
  },
  children: [policyLawRoute, guidanceRoute, PublicAnnouncementRoute, fileDownloadRoute]
};
